import { RequestOptions } from './request-options';

export class PlanRequest extends RequestOptions {
    Id_User: number;
    Id_Session: string;
    NWeek: number;
    Id_Profile: number;
    FullName: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/plan-request.ts